import { useQuery } from 'react-query';
import { MeetingFile } from 'src/core/types';

import axios from './axios';

export interface UseMeetingFilesProps {
  roomAddress: string;
}

export function useMeetingFiles(props: UseMeetingFilesProps) {
  const { roomAddress } = props;

  return useQuery<MeetingFile[]>(
    ['meeting-files', roomAddress],
    async () => {
      return axios
        .get<MeetingFile[]>(`/api/v1/rooms/${roomAddress}/files/`)
        .then((res) => res.data);
    },
    {
      suspense: false,
    },
  );
}
